/**
 * Base class for all tc components
 */
export class TcComponent {
  constructor() {}
}
